import React from 'react';
import styled from 'styled-components';
import { SPWClickAwayTooltip } from 'spw-shared/globalComponents';
import { DraggableTooltipContainer } from 'spw-components/worksheet/styles';
import useUnitConversion from 'spw-components/unit-conversion/hooks';

const InfoItem = styled.div`
  .title {
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-transform: uppercase;
  }
  .content {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  margin-bottom: 8px;
  :last-child {
    margin-bottom: 0px;
  }
`;

export const CalculationDefinitionsDialog = () => {
  const { getUnit, getUnitName } = useUnitConversion();
  const infoList = [
    {
      title: `SUBTOTAL ${getUnit('area')} (or ${getUnit('net-area')})`,
      unabbreviatedTitle: `NET SQUARE ${getUnitName(
        'main-unit'
      ).toUpperCase()}`,
      content: `The square ${getUnitName(
        'main-unit'
      )} of usable spaces before adding circulation.`,
    },
    {
      title: 'CIRCULATION',
      content: 'The main routes connecting usable spaces to the common areas.',
    },
    {
      title: 'PLANNING FACTOR (or fit factor)',
      content: `Additional square ${getUnitName(
        'main-unit'
      )} to account for architectural inefficiencies. Optional.`,
    },
    {
      title: getUnit('area'),
      unabbreviatedTitle: `USABLE SQUARE ${getUnitName(
        'main-unit'
      ).toUpperCase()}`,
      content: `${getUnit('net-area')} plus circulation and planning factor.`,
    },
    {
      title: 'RENTABLE LOAD FACTOR',
      content: '% of common building spaces that tenants pay for. Optional.',
    },
    {
      title: getUnit('rentable-area'),
      unabbreviatedTitle: `RENTABLE SQUARE ${getUnitName(
        'main-unit'
      ).toUpperCase()}`,
      content: `${getUnit(
        'area'
      )} plus a rentable load factor added by the landlord.`,
    },
    {
      title: `${getUnit('gross-area')} *`,
      unabbreviatedTitle: `GROSS SQUARE ${getUnitName(
        'main-unit'
      ).toUpperCase()}`,
      content: `${getUnit(
        'rentable-area'
      )} plus vertical penetrations like building core, stairwells, and elevator shafts.`,
    },
  ];

  return (
    <SPWClickAwayTooltip height={658} width={298} placement="bottom-right">
      <DraggableTooltipContainer>
        <div
          id="draggable-dialog-title"
          className="title"
          style={{
            fontSize: '18px',
            lineHeight: '24px',
            fontWeight: 500,
          }}
        >
          Summary Calculation Definitions
        </div>
        <div className="content">
          <div>
            {infoList.map((info) => (
              <InfoItem key={info.title}>
                <div className="title">{info.title}</div>
                {info.unabbreviatedTitle && (
                  <div className="content">{info.unabbreviatedTitle}</div>
                )}
                <div className="content">{info.content}</div>
              </InfoItem>
            ))}
          </div>
          <div style={{ marginTop: '16px', fontSize: '12px', fontWeight: 400 }}>
            * Not included in Space Plan Wizard calculations.
          </div>
        </div>
      </DraggableTooltipContainer>
    </SPWClickAwayTooltip>
  );
};

export default CalculationDefinitionsDialog;
